import { render } from "./HomeProjects.vue?vue&type=template&id=3f55d7c2&scoped=true"
import script from "./HomeProjects.vue?vue&type=script&lang=js"
export * from "./HomeProjects.vue?vue&type=script&lang=js"

import "./HomeProjects.vue?vue&type=style&index=0&id=3f55d7c2&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f55d7c2"]])

export default __exports__